export const useOpeningTimes = () => {
  const { locale, t } = useI18n({ useScope: 'global' })
  const timeTable = {
    endTimeWeek: '18:30',
    startTimeWeek: '9:30',
  }

  const localizedTimetable = computed(() => ({
    startTimeWeek: isLessThanFourHoursDifference()
      ? convertTimeByTimezone({
          time: timeTable.startTimeWeek,
          locale: locale.value,
        })
      : formatTime(timeTable.startTimeWeek, locale.value),
    endTimeWeek: isLessThanFourHoursDifference()
      ? convertTimeByTimezone({
          time: timeTable.endTimeWeek,
          locale: locale.value,
        })
      : formatTime(timeTable.endTimeWeek, locale.value),
  }))

  const message = computed(() =>
    t('contact.openingTimes', {
      ...localizedTimetable.value,
      zoneLabel: t(
        `contact.timeZone.${isLessThanFourHoursDifference() ? 'local' : 'paris'}`,
      ),
    }),
  )

  const messageShort = computed(() =>
    t('contact.openingTimesShort', {
      ...localizedTimetable.value,
      zoneLabel: t(
        `contact.timeZone.${isLessThanFourHoursDifference() ? 'local' : 'paris'}`,
      ),
    }),
  )

  return {
    message,
    messageShort,
  }
}
